enum ProductGroup {
  TRUE_PLATFORM = 'true.platform',
  TEST_CREATION = 'test.creation',
  TEST_EXECUTION = 'test.execution',
  TESTOPS = 'test.operation',
  ADVANCED_WEB_TESTING = 'advanced.web.testing',
}

export { ProductGroup };
